import $ from 'jquery'
import {ReportChartType, ReportGroupingLevel} from '../../constants'
import messageResource from '../../../messageResource'
import {escapeHtmlSymbols} from '../../../atUtils'
import UserTime from '../../../user_time'
import NumberFormatter from '../../../number_formatter'
import {DateFormat} from '../../../date_format'
import {DEFAULT_TIME_ZONE_GROUP_ID, OTHER_USER_GROUPS_ENTITY_ID, OTHER_USERS_ENTITY_ID, TimeFormat} from 'constants'
import UserNameFormat from '../../../util/UserNameFormat'

export default class BaseFormatterCreator {

    constructor() {
        this.DATE_FORMAT = window.SystemSettings.dateFormat
        this.TIME_FORMAT = window.SystemSettings.defaultTimeFormatForHTMLReports
    }

    getCategoryToStringFunction(selectedCategoryType) {
        switch (selectedCategoryType) {
            case ReportGroupingLevel.USER:
                return (user) => {
                    if (user.id === OTHER_USERS_ENTITY_ID) {
                        return messageResource.getMessage("report.other_users")
                    }
                    return UserNameFormat.formatLFM(user.firstName, user.lastName, user.middleName)
                }
            case ReportGroupingLevel.USER_GROUP:
                return (group) => {
                    if (group.id === window.SystemSettings.usersWithoutGroupId) {
                        return messageResource.getMessage("common.users_without_group")
                    }
                    if (group.id === OTHER_USER_GROUPS_ENTITY_ID) {
                        return messageResource.getMessage("report.other_user_groups")
                    }
                    return group.name
                }
            case ReportGroupingLevel.TIME_ZONE_GROUP:
                return (group) => {
                    let name = group.name
                    if (group.id === DEFAULT_TIME_ZONE_GROUP_ID) {
                        name += " " + messageResource.getMessage("common.default_group")
                    }
                    return name
                }
            case ReportGroupingLevel.LEAVE_TYPE:
                return (leaveType) => {
                    return leaveType.name
                }
            case ReportGroupingLevel.CUSTOMER:
                return (customer) => {
                    return customer.name
                }
            case ReportGroupingLevel.PROJECT:
                return (project) => {
                    return project.name + " (" + project.customerInfo.name + ")"
                }
            case ReportGroupingLevel.BILLING_TYPE:
                return (type) => {
                    return type.name
                }
            case ReportGroupingLevel.DATE:
                return (date) => {
                    if ($.isEmptyObject(date)) return ""
                    return new DateFormat(this.DATE_FORMAT).formatDate(date.parseJSONDate())
                }

            case ReportGroupingLevel.WEEK:
                return (week) => {
                    if ($.isEmptyObject(week)) return ""
                    const from = week.from.parseJSONDate()
                    const to = week.to.parseJSONDate()
                    const firstPart = week.from === week.to ? "" : new DateFormat('MMM dd').formatDate(from) + " - "
                    return firstPart + new DateFormat('MMM dd, yyyy').formatDate(to)
                }

            case ReportGroupingLevel.MONTH:
                return (month) => {
                    if ($.isEmptyObject(month)) return ""
                    return new DateFormat('MMMM , yyyy').formatDate(month.parseJSONDate())
                }
        }
    }

    getValueFormattedFunction(selectedValueType) {
        const numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

        switch (selectedValueType) {
            case ReportChartType.APPROVED_WORKING_HOURS:
            case ReportChartType.LEAVE_HOURS:
            case ReportChartType.OVERTIME_HOURS:
            case ReportChartType.TOTAL_WORKING_HOURS:
                return (value) => {
                    if (!value.toString().length) return ""
                    return this.TIME_FORMAT === TimeFormat.TIME ?
                           UserTime.formatTime(value) :
                           numberFormatter.format(value / 60)
                }
            case ReportChartType.PTO_BALANCE:
                return (value) => {
                    return numberFormatter.format(window.SystemSettings.showPTOInHours ? value * (DEFAULT_WORKDAY_DURATION / 60) : value)
                }
            case ReportChartType.SICK_DAYS_BALANCE:
                return (value) => {
                    return numberFormatter.format(window.SystemSettings.showSickInHours ? value * (DEFAULT_WORKDAY_DURATION / 60) : value)
                }
            case ReportChartType.BILLABLE_AMOUNTS:
            case ReportChartType.COST_OF_WORK:
                return (value) => {
                    return numberFormatter.format(value)
                }
        }
    }

    getMeasureUnit(selectedValueType) {
        switch (selectedValueType) {
            case ReportChartType.APPROVED_WORKING_HOURS:
            case ReportChartType.LEAVE_HOURS:
            case ReportChartType.OVERTIME_HOURS:
            case ReportChartType.TOTAL_WORKING_HOURS:
                return messageResource.getMessage("report.create_chart.man_hours_sign")
            case ReportChartType.PTO_BALANCE:
                return window.SystemSettings.showPTOInHours ?
                       messageResource.getMessage("report.create_chart.hours_sign") :
                       messageResource.getMessage("report.create_chart.days_sign")
            case ReportChartType.SICK_DAYS_BALANCE:
                return window.SystemSettings.showSickInHours ?
                       messageResource.getMessage("report.create_chart.hours_sign") :
                       messageResource.getMessage("report.create_chart.days_sign")
            case ReportChartType.BILLABLE_AMOUNTS:
            case ReportChartType.COST_OF_WORK:
                return escapeHtmlSymbols(window.SystemSettings.currencySign)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/BaseFormatterCreator.js